<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'ErrorAlert',
  mixins: [baseMixin],
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  computed: {
    errorMessage() {
      try {
        return this.error.message
      } catch {
        return `An error occurred while trying to process your request`
      }
    },
  },
}
</script>

<template>
  <v-alert v-bind="$attrs" v-on="$listeners">
    {{ errorMessage }}
  </v-alert>
</template>
